import { Card, Box } from '@material-ui/core';
import { InfoButton } from '@components/Buttons';
import { useState } from 'react';
import SliderComponent from '../../components/Slider';
import CultureProfileCharts from '../../components/CultureProfileCharts';
import { MindgageScoresTooltip } from '../../components/MindgageScoresTooltip';
import EmptyContent from '../../components/EmptyContent';
import useLocales from '../../hooks/useLocales';

interface MindgageMetric {
  id: number;
  name: string;
  description?: string;
}

interface MindgageMetricsStepProps {
  metrics: MindgageMetric[];
  scores: number[];
  setScores: (index: number, score: number) => void;
}

const MindgageMetricsStep = ({
  metrics,
  scores,
  setScores
}: MindgageMetricsStepProps): JSX.Element => {
  const { t } = useLocales();
  const [mindgageScoresTooltipIsOpen, setMindgageScoresTooltipIsOpen] =
    useState(false);

  if (!metrics || metrics.length === 0) {
    return <EmptyContent title={t('Loading Mindgage metrics...')} />;
  }

  // Prepare data for chart
  const labels = metrics.map((metric) => metric.name);
  const points = metrics.map((metric, i) => scores[i] || 1);
  const descriptions = metrics.map((metric) => ({
    id: metric.id,
    name: metric.name,
    description: metric.description || ''
  }));

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%'
      }}
    >
      <Card sx={{ p: 2, m: 1, width: '48%' }}>
        <Box sx={{ position: 'absolute', right: '16px', top: '16px' }}>
          <InfoButton onClick={() => setMindgageScoresTooltipIsOpen(true)} />
        </Box>
        {metrics.map((metric: MindgageMetric, i: number) => (
          <SliderComponent
            key={metric.id}
            title={metric.name}
            minVal={1}
            maxVal={5}
            values={scores[i] || 1}
            handleSetValues={(values: number[] | number) => {
              const score = typeof values === 'number' ? values : values[0];
              setScores(i, score);
            }}
          />
        ))}
      </Card>
      <Card sx={{ p: 2, m: 1, width: '48%' }}>
        <CultureProfileCharts
          isMindgage={true}
          labels={labels}
          points={points}
          descriptions={descriptions}
          profile={true}
          showTooltips={false}
          minScale={1}
          maxScale={5}
          mindgageScoresTooltipIsOpen={mindgageScoresTooltipIsOpen}
          setMindgageScoresTooltipIsOpen={setMindgageScoresTooltipIsOpen}
        />
      </Card>
      <MindgageScoresTooltip
        open={mindgageScoresTooltipIsOpen}
        onClose={() => setMindgageScoresTooltipIsOpen(false)}
      />
    </Box>
  );
};

export default MindgageMetricsStep;
